import {
  BetaFeaturesEnum,
  GetBetaFeaturesResponse,
} from '@src/api/beta-features/get-beta-features';

export function hasCommonApplicationV2Enabled(
  data: GetBetaFeaturesResponse[],
): boolean {
  return (
    data.find(([key]) => key === BetaFeaturesEnum.COMMON_APPLICATION_V2)?.[1] ??
    false
  );
}
